export function isArrayOfNumber(value: unknown): value is number[] {
	return Array.isArray(value) && value.every(item => typeof item === 'number');
}

export function isArrayOfString(value: unknown): value is string[] {
	return Array.isArray(value) && value.every(item => typeof item === 'string');
}

export function isOneOfTypes(value: unknown, types: string[]) {
	return types.includes(typeof value);
}

export default {
	isArrayOfNumber,
	isArrayOfString,
	isOneOfTypes
};
